import styled from 'styled-components'

export const PageRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 80px;
  padding: 24px;
  background:
    radial-gradient(circle at top center, ${p => p.theme.palette.colors.backgroundSoft} 0%, ${p => p.theme.palette.colors.background} 42%),
    ${p => p.theme.palette.colors.background};

  @media(max-width: 991px){
    padding: 16px 16px 40px;
  }
`;

export const LayoutGrid = styled.div.attrs({})`
  display: grid;
  width: 100%;
  max-width: 1520px;
  grid-template-columns: minmax(0, 1.68fr) minmax(320px, 0.82fr);
  gap: 32px;
  align-items: start;

  @media(max-width: 1180px){
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const LeftColumn = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 44px;
  line-height: 1.04;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};

  @media(max-width: 991px){
    font-size: 34px;
  }
`;

export const HeaderText = styled.div.attrs({})`
  margin-top: 10px;
  font-family: Lato;
  font-size: 16px;
  color: ${p => p.theme.palette.colors.muted};
`;

export const ErrorState = styled.section.attrs({})`
  display: flex;
  width: 100%;
  max-width: 720px;
  min-height: 320px;
  padding: 48px;
  border: 1px solid ${p => p.theme.palette.colors.border};
  border-radius: 20px;
  background: ${p => p.theme.palette.colors.backgroundSoft};
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  ${HeaderText} {
    margin: 14px 0 28px;
  }

  @media(max-width: 991px){
    min-height: 260px;
    padding: 32px 24px;
  }
`;

export const CategoryBadge = styled.div.attrs({})`
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 6px 16px;
  border-radius: 999px;
  background: ${p => p.theme.palette.colors.badgeMuted};
  color: ${p => p.theme.palette.colors.text};
  font-family: Poppins;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 22px;
`;

export const RightColumn = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StatsGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media(max-width: 560px){
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const LegacyHeader = styled.div.attrs({})`
  display: flex;
  width: 100%;
  max-width: 1520px;
  gap: 24px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const LegacyContent = styled.div.attrs({})`
  width: 100%;
  max-width: 1520px;
  margin-top: 24px;
`;
